export default {
  methods: {
    async getCsv(dirName) {
      const settingJsonRes = await fetch(this.generateSettingJsonPath(dirName));
      let settingJson;

      try {
        settingJson = await settingJsonRes.json();
      } catch {
        return [];
      }

      if (settingJson.loadCsvName.length === 0) return;

      const csvs = await Promise.all(
        settingJson.loadCsvName.map(async v => {
          const res = await fetch(this.generateCSVPath(dirName, v));
          const text = await res.text();
          return text;
        }),
      );

      console.log(`loadCsvs__${dirName}`, csvs);

      const convertCsvs = this.convertCSVRowToArray(csvs);
      // const convertCsvs = csvs.map(_ => {
      //   const data = _.trim()
      //     .split("\n")
      //     .map(line => line.split(",").map(x => x.trim()));
      //   data.shift();
      //   const setData = data.filter(_ => _[4] !== "");
      //   return setData;
      // });

      console.log(`convertCsvs__${dirName}`, convertCsvs);

      const setCsvs = this.joinArray(convertCsvs);

      console.log(`completedCsvs${dirName}`, setCsvs);

      return setCsvs;
    },
    generateCSVPath(dirName, csvName) {
      return `${process.env.VUE_APP_BASE_URL}/assets/custom/${this.currentUser.mansion.dai_bunrui}/${this.currentUser.mansion.chu_bunrui}/${this.currentUser.mansion._id}/csv/${dirName}/${csvName}.csv`;
    },
    generateSettingJsonPath(dirName) {
      return `${process.env.VUE_APP_BASE_URL}/assets/custom/${this.currentUser.mansion.dai_bunrui}/${this.currentUser.mansion.chu_bunrui}/${this.currentUser.mansion._id}/csv/${dirName}/setting.json`;
    },
    convertCSVRowToArray(csvs) {
      const arr = csvs.map(_ => {
        //行ごとに配列に変換する
        let data = _.trim()
          .split("\n")
          .map(line => line.split(",").map(x => x.trim()));
        //先頭一行目（タイトル部分）を削除
        data.shift();
        return data;
      });
      return arr;
    },
    joinArray(arrs) {
      let resArr = [];
      arrs.map(arr => {
        arr.map(_ => {
          resArr.push(_);
        });
      });
      return resArr;
    },
  },
};
